import React from 'react';
class Dots extends React.PureComponent {
    render() {
        const { tmpl, current, total } = this.props;
        return tmpl(current, total);
    }
}
export default Dots;
